import type { DeckDoc } from '../types/slide-doc';

// Eagerly fetch every image referenced by any slide so transitions
// are instant on mobile networks. Runs in background; never blocks.
export function preloadDeckImages(deck: DeckDoc): Promise<void> {
  const srcs = new Set<string>();
  for (const slide of deck.slides) {
    for (const shape of slide.shapes) {
      if (shape.type === 'image' && shape.src) srcs.add(shape.src);
    }
  }
  if (srcs.size === 0) return Promise.resolve();
  return Promise.all(
    [...srcs].map(
      (src) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          img.onload = () => resolve();
          img.onerror = () => resolve(); // missing assets don't block start
          img.src = src;
        })
    )
  ).then(() => undefined);
}
